import { TabMenuSimple } from '../shared/components-generals/tab-menu-simple/tab-menu-simple';
import { LocationDetailResponse } from '../shared/models/location-model/location.model';
import { ProfileComponent } from '../user/profile-component/profile-component';
import { Product } from '../shared/models/products-model/products.model';
import { CartProducts } from '../product/cart-products/cart-products';
import { ProductsService } from '../shared/services/products.service';
import { LocationService } from '../shared/services/location.service';
import { GeneralService } from '../shared/services/general.service';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { Products } from '../product/products/products';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule, Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ProfileComponent,
    TranslateModule,
    MatButtonModule,
    MatBadgeModule,
    MatIconModule,
    TabMenuSimple,
    CommonModule,
    CartProducts,
    Products,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  private contSubscription!: Subscription;
  private locationSubscription!: Subscription;
  public cont = 0;
  public statusSelected = 0;
  public taps = [
    { descripcion: 'Home', icon: 'icon_home' },
    { descripcion: 'Mi Carrito', icon: 'icon_carrito' },
    { descripcion: 'Mi Perfil', icon: 'icon_perfil' },
  ];
  public search = new FormControl();
  public SearchFieldValue = new FormControl();
  public productInCar: { [key: string]: Product } = {};
  public locationDetailArray: LocationDetailResponse[] = [];
  public locationDetail: LocationDetailResponse | null = null;
  private routerSub!: Subscription;

  constructor(
    private servicesGeneral: GeneralService,
    public http: HttpClient,
    public dialog: MatDialog,
    public productsService: ProductsService,
    public locationService: LocationService,
    private location: Location,
  ) {}

  ngOnInit() {
    this.addProducts();
    this.changeLocationDetail();
    // leer Params
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('statusSelected');

    if (status !== null) {
      this.statusSelected = Number(status);
    } else {
      this.servicesGeneral.addParamToUrl([], { statusSelected: this.statusSelected });
    }
    this.getLocationDetail();
    this.listenToStatusSelectedParam();
  }

  ngOnDestroy() {
    if (this.contSubscription) {
      this.contSubscription.unsubscribe();
    }
    if (this.locationSubscription) {
      this.locationSubscription.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  private addProducts() {
    const saved = localStorage.getItem('productInCar');
    if (saved) {
      this.productInCar = JSON.parse(saved);
    }

    this.contSubscription = this.productsService.emitProduct.subscribe((item) => {
      if (item.amount == 0) {
        delete this.productInCar[item.Id];
      } else {
        this.productInCar[item.Id] = item;
      }
      localStorage.setItem('productInCar', JSON.stringify(this.productInCar));
      this.cont = this.getTotalAmount();
      this.productsService.emitCont.emit(this.cont);
    });

    this.contSubscription = this.productsService.deleteProducts.subscribe(() => {
      localStorage.removeItem('productInCar');
      this.productInCar = {};
      this.cont = 0;
      this.productsService.emitCont.emit(this.cont);
    });
  }

  public getTotalAmount(): number {
    return Object.values(this.productInCar).reduce(
      (total, product) => total + (product.amount || 0),
      0,
    );
  }

  public onStatusSelectedChange(event: number) {
    if (this.statusSelected != event) {
      // this.statusSelected = event;
      this.servicesGeneral.addParamToUrl([], { statusSelected: event });
    }
  }

  public getLocationDetail() {
    const services = [126760, 127498, 109155, 127292, 127705].map((id) => {
      return this.locationService.getLocationDetail(id);
    });
    this.servicesGeneral.getServices(services).then((locations) => {
      const location = localStorage.getItem('location');
      const locationDetail = JSON.parse(location || 'null');
      locations.forEach((element, index) => {
        this.locationDetailArray.push(element!.Data);
        if (index === 0) {
          this.locationDetail = element!.Data;
        }
        if (locationDetail && locationDetail.Id === element!.Data.Id) {
          this.locationDetail = element!.Data;
        }
      });
    });
  }

  public changeLocationDetail() {
    this.locationSubscription = this.productsService.emitLocation.subscribe(
      (locationDetail: LocationDetailResponse) => {
        this.locationDetail = locationDetail;
      },
    );
  }

  public listenToStatusSelectedParam(): void {
    this.location.onUrlChange((url: string) => {
      const queryString = url.split('?')[1] || '';
      const params = new URLSearchParams(queryString);
      const status = params.get('statusSelected');
      if (status !== null) {
        this.statusSelected = Number(status);
      }
    });
  }
}
